import React, { ReactElement } from "react";
import content from "./content";
import { useRouter } from "next/router";
import styles from "./styles.module.scss";

export default function Benefits(): ReactElement {
    const { query } = useRouter();

    const item = content[query.tool as keyof typeof content];

    return (
        <section className={styles.benefits}>
            <h2 className="mb-8">{item?.title}</h2>
            <div>
                {item?.points.map((point, index) => (
                    <div key={index}>
                        <h3 className="flex items-end gap-5 mb-4 font-bold">
                            <span className="children:w-10">{point.icon}</span>{" "}
                            {point.title}
                        </h3>
                        <p>{point.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
